export default __webpack_public_path__ + "static/media/danskeheadline-webfont.b269a819.eot";